module.exports = __webpack_public_path__ + "static/media/ico-check-green.7d6fcca1.svg";